<div class="app-foot">
  <div class="app-foot">
    <div class="app-foot-links">
      @if (!hideLink) {
        <span >
          <a  [href]="href" target="_blank" class="app-foot-link" alt="FREQUENTLY ASKED QUESTIONS (opens in new window)" >
            FREQUENTLY ASKED QUESTIONS
          </a>
        </span>
      }
      @if (hideLink) {
        <span class="app-foot-link"></span>
      }
    </div>
  </div>
</div>
